if (!customElements.get('kit-tabs')) {
  customElements.define(
    'kit-tabs',
    class KitTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', this.onKeydown.bind(this));
        });

        const initial = Math.max(
          this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'),
          0
        );
        this.activate(initial, false);
      }

      activate(index, focus = true) {
        if (!this.tabs[index]) return;

        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });

        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });

        if (focus) this.tabs[index].focus();
      }

      onKeydown(event) {
        const current = this.tabs.indexOf(event.currentTarget);
        if (current === -1) return;

        let next = null;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = (current + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = (current - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.activate(next);
      }
    }
  );
}

// Theme editor: selecting a Tab or Image block reveals the matching tab panel.
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:block:select', (event) => {
    const kitTabs = event.target.closest('kit-tabs');
    if (!kitTabs) return;

    const tab = event.target.closest('[role="tab"]');
    const panel = event.target.closest('[role="tabpanel"]');

    let index = -1;
    if (tab) index = kitTabs.tabs.indexOf(tab);
    else if (panel) index = kitTabs.panels.indexOf(panel);

    if (index > -1) kitTabs.activate(index, false);
  });
}
